module.exports = __webpack_public_path__ + "static/media/server_down.bcdcf6f7.svg";